module.exports = "../images/cabin-hero-v2@2x.jpg?v=c7a04bd";